import React from 'react';
import { Box } from '@mui/joy';
import { CampaignAvatar } from  '../Snippet'

const CellCampaignNameAndIcon = ({nameField, iconField}) => {

    return (
        <Box className={"list-element-cell cell-legalentity"}>
            {
                nameField && <CampaignAvatar name={nameField} url={iconField} withname={true}/>
            }
        </Box>
    );
}

export default CellCampaignNameAndIcon